import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	

    sessionStorage.getItem("PurchaseOnly_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');

   if(sessionStorage.getItem("PurchaseOnly_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setBillNo("{Auto}");
     
      //Clear();
   
   }
   else if(sessionStorage.getItem("PurchaseOnly_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("PurchaseOnly_EditId"));
   }
   else if(sessionStorage.getItem("PurchaseOnly_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("PurchaseOnly_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }



  function CustEntryClose()
  {
    setxCustName('');
    setxMobile('');
    setxAddress1('');
    setxAddress2('');
    setxAddress3('');
    setxArea('');
    setxCity('');
    setxPinCode('');
    setxPhoneNo('');
    setxEmailId('');

    CustEntryhandleClose1();

  }
  function CustOpen()
  {
    
    setCustSearchTxt('');
    setdtCust([]);
    setdtCust_Org([]);
    CusthandleShow1();

  
    GetCustList('{'+CustIdRef.current+'}');

    
  }
  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtEmp, setdtEmp,dtEmpRef]=useStateRef([]);
  const [dtChqBank, setdtChqBank]=useState([]);
  
  const [btndisabled, setDisabled] = useState('disabled');
  const [dtBillType, setdtBillType, dtBillTypeRef]=useStateRef([]);
  const [BillType, setBillType, BillTypeRef]=useStateRef('PU');

  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtTag, setdtTag]=useState([]);
  const [dtTagInfo, setdtTagInfo]=useState([]);
  const [dtTagList,setdtTagList]=useState([]);

  const [dtMetal, setdtMetal]=useState([]);
  const [dtCategory, setdtCategory]=useState([]);
  
  const [dtCust, setdtCust,dtCustRef]=useStateRef([]);
  const [dtCust_Org, setdtCust_Org,dtCust_OrgRef]=useStateRef([]);
  



  const [DtPurDetTable, setDtPurDetTable, DtPurDetTableRef]=useStateRef([]);
  let PurDetTable=[];





  const [Purchaseshow1, setPurchaseshow1] = useState(false);
  const PurchasehandleClose1 = () => setPurchaseshow1(false);
  const PurchasehandleShow1 = () => setPurchaseshow1(true);
  
  const [Chequeshow1, setChequeshow1] = useState(false);
  const CheuqehandleClose1 = () => setChequeshow1(false);
  const ChequehandleShow1 = () => setChequeshow1(true);
  
  
  const [Custshow1, setCustshow1] = useState(false);
  const CusthandleClose1 = () => setCustshow1(false);
  const CusthandleShow1 = () => setCustshow1(true);
  
  const [CustEntryshow1, setCustEntryshow1] = useState(false);
  const CustEntryhandleClose1 = () => setCustEntryshow1(false);
  const CustEntryhandleShow1 = () => setCustEntryshow1(true);
  
  
   const [BillNo, setBillNo, BillNoRef] = useStateRef(0);
   const [BillDate, setBillDate, BillDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [isNewBill, setisNewBill, isNewBillRef] = useStateRef(false);
   


   
//Cheque Details
   const [ChqBankName,setChqBankName,ChqBankNameRef]=useStateRef('');
   const [ChqNo,setChqNo,ChqNoRef]=useStateRef('');
   const [ChqDate,setChqDate,ChqDateRef]= useStateRef((new Date()).toISOString().substring(0,10));
   const [ChqAmount,setChqAmount,ChqAmountRef]=useStateRef('');

//Purchase Details
   const [PurId,setPurId,PurIdRef]=useStateRef('');
   const [PurBillNo,setPurBillNo,PurBillNoRef]=useStateRef('');
   const [PurBillDate,setPurBillDate,PurBillDateRef]=useStateRef((new Date()).toISOString().substring(0,10));
   const [PurMetal,setPurMetal,PurMetalRef]=useStateRef('');
   const [PurCategory,setPurCategory,PurCategoryRef]=useStateRef('');
   const [PurPcs,setPurPcs,PurPcsRef]=useStateRef(0);
   const [PurGrossWt,setPurGrossWt,PurGrossWtRef]=useStateRef(0);
   const [PurPurity,setPurPurity,PurPurityRef]=useStateRef(0);
   const [PurWasteP,setPurWasteP,PurWastePRef]=useStateRef(0);
   const [PurWasteGrm,setPurWasteGrm,PurWasteGrmRef]=useStateRef(0);
   const [PurWastage,setPurWastage,PurWastageRef]=useStateRef(0);
   const [PurNetWt,setPurNetWt,PurNetWtRef]=useStateRef(0);
   const [PurMC,setPurMC,PurMCRef]=useStateRef(0);
   const [PurRate,setPurRate,PurRateRef]=useStateRef(0);
   const [PurStoneAmt,setPurStoneAmt,PurStoneAmtRef]=useStateRef(0);
   const [PurAmount,setPurAmount,PurAmountRef]=useStateRef(0);
   const [PurStoneWt,setPurStoneWt,PurStoneWtRef]=useStateRef(0);
   const [PurTax,setPurTax,PurTaxRef]=useStateRef(0);
  
//Emp Details
   const [EmpId1,setEmpId1,EmpId1Ref]=useStateRef('');
   const [EmpName1,setEmpName1,EmpName1Ref]=useStateRef('');

//Customer Details
   const [CustId,setCustId,CustIdRef]=useStateRef(0);
   const [CustName,setCustName,CustNameRef]=useStateRef('');
   const [CustBillName,setCustBillName,CustBillNameRef]=useStateRef('');
   
   const [Mobile,setMobile,MobileRef]=useStateRef('');
   const [Address1,setAddress1,Address1Ref]=useStateRef('');
   const [Address2,setAddress2,Address2Ref]=useStateRef('');
   const [Address3,setAddress3,Address3Ref]=useStateRef('');
   const [Area,setArea,AreaRef]=useStateRef('');
   const [City,setCity,CityRef]=useStateRef('');
   const [PinCode,setPinCode,PinCodeRef]=useStateRef('');
   const [PhoneNo,setPhoneNo,PhoneNoRef]=useStateRef('');
   const [EmailId,setEmailId,EmailIdRef]=useStateRef('');
   const [AdharNo,setAdharNo,AdharNoRef]=useStateRef('');
   const [PanNo,setPanNo,PanNoRef]=useStateRef('');
  

   const [xCustId,setxCustId,xCustIdRef]=useStateRef(0);
   const [xCustName,setxCustName,xCustNameRef]=useStateRef('');
   const [xMobile,setxMobile,xMobileRef]=useStateRef('');
   const [xAddress1,setxAddress1,xAddress1Ref]=useStateRef('');
   const [xAddress2,setxAddress2,xAddress2Ref]=useStateRef('');
   const [xAddress3,setxAddress3,xAddress3Ref]=useStateRef('');
   const [xArea,setxArea,xAreaRef]=useStateRef('');
   const [xCity,setxCity,xCityRef]=useStateRef('');
   const [xPinCode,setxPinCode,xPinCodeRef]=useStateRef('');
   const [xPhoneNo,setxPhoneNo,xPhoneNoRef]=useStateRef('');
   const [xEmailId,setxEmailId,xEmailIdRef]=useStateRef('');
   const [xAdharNo,setxAdharNo,xAdharNoRef]=useStateRef('');
   const [xPanNo,setxPanNo,xPanNoRef]=useStateRef('');
   const [xRefMobileNo,setxRefMobileNo,xRefMobileNoRef]=useStateRef('');
   const [xRefCustId,setxRefCustId,xRefCustIdRef]=useStateRef('');
   const [xRefRelation,setxRefRelation,RefxRelationRef]=useStateRef('');
   const [xRefCustName,setxRefCustName,xRefCustNameRef]=useStateRef('');
 
  
   const [CustSearchTxt, setCustSearchTxt, CustSearchTxtRef] = useStateRef('');
   const [dtCustRelation, setdtCustRelation, dtCustRelationRef] = useStateRef([]);
   
   const [ShowCustBillDetail, setShowCustBillDetail, ShowCustBillDetailRef] = useStateRef(true);

   //Bill Details

   const [PurchaseWt, setPurchaseWt, PurchaseWtRef] = useStateRef(0);
   const [PurchaseAmount, setPurchaseAmount, PurchaseAmountRef] = useStateRef(0);
   const [PurchaseTax, setPurchaseTax, PurchaseTaxRef] = useStateRef(0);

   const [BillAmount, setBillAmount, BillAmountRef] = useStateRef(0);
   const [DisP, setDisP, DisPRef] = useStateRef(0);
   const [Discount, setDiscount, DiscountRef] = useStateRef(0);
   const [Credit, setCredit, CreditRef] = useStateRef(0);
   const [Cash, setCash, CashRef] = useStateRef(0);
   const [Cheque, setCheque, ChequeRef] = useStateRef(0);
   const [NetAmount, setNetAmount, NetAmountRef] = useStateRef(0);
   const [TaxP, setTaxP, TaxPRef] = useStateRef(0);
   const [TaxAmount, setTaxAmount, TaxAmountRef] = useStateRef(0);
   
   const [TotalPaid, setTotalPaid, TotalPaidRef] = useStateRef(0);
   const [BalancePaid, setBalancePaid, BalancePaidRef] = useStateRef(0);
  

   
/*
function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.No.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  
*/

async function CustEdit(id)
{
  try {

    let postData = {
      "CustId" : id
     };
     
  
    const results = await apiService.postCall("purchaseonly/custdisplay",postData);
  
    if (results != "-1") {

      setxCustId(results.data[0][0].CustId);
      setxCustName(results.data[0][0].CustomerName)
      setxMobile(results.data[0][0].Mobile)
      setxAddress1(results.data[0][0].Address1)
      setxAddress2(results.data[0][0].Address2)
      setxAddress3(results.data[0][0].Address3)
      setxArea(results.data[0][0].Area)
      setxCity(results.data[0][0].City)
      setxPinCode(results.data[0][0].PinCode)
      setxPhoneNo(results.data[0][0].Phone)
      setxEmailId(results.data[0][0].EmailId)
      setxAdharNo(results.data[0][0].AdharNo)
      setxPanNo(results.data[0][0].PanNo)
      setxRefCustId(results.data[0][0].RefCustId)
      setxRefMobileNo(results.data[0][0].RefMobile)
      setxRefCustName(results.data[0][0].RefCustName)
      setxRefRelation(results.data[0][0].RefRelation)

      

      CustEntryhandleShow1();
     }
  } catch (error) {
       console.log(error);
     }
}


function CustSelect(id)
{

  var result = dtCustRef.current.find(obj => {
    return obj.CustId === id
  });
if(result!=undefined)
{

 
  setMobile(result.Mobile);
  setCustName(result.CustomerName);
  setCustId(result.CustId);
  setAddress1(result.Address1);
  setAddress2(result.Address2);
  setAddress3(result.Address3);
  setArea(result.Area);
  setCity(result.City);
  setPinCode(result.PinCode);
  setPhoneNo(result.Phone);
  setEmailId(result.EmailId);
  setPanNo(result.PanNo);
  setAdharNo(result.AdharNo);
 

}
else
{

} 

CusthandleClose1();

}




function getEmpName(id)
{
if(id==1)
{
  var result = dtEmpRef.current.find(obj => {
    return obj.OprCode === EmpId1Ref.current
  });
if(result!=undefined)
  setEmpName1(result.OprName);
else
  setEmpName1(""); 
}


}







 
   async function PurchaseClear()
   {
    
    if((PurMetalRef.current.length>0) || (PurCategoryRef.current.length>0))
    {
    setPurBillNo('');
    setPurMetal('');
    setPurCategory('');
    setPurPcs('');
    setPurGrossWt('');
    setPurNetWt('');
    setPurStoneWt('');
    setPurStoneAmt('');
    setPurWasteGrm('');
    setPurWasteP('');
    setPurMC('');
    setPurRate('');
    setPurPurity('');
    setPurAmount('');
    setBillType('PU');
  }
  else
  {PurchasehandleClose1();
	}
    


	 	
   }


   async function ChequeOpen()
   {
    ChequehandleShow1();
   }
   async function ChequeOK()
   {
    
    if((ChqBankNameRef.current.length>0) && (val(ChqAmountRef.current)>0) && (ChqNoRef.current.length>0))
     {
      setCheque(ChqAmountRef.current);
      BillCalc();

      CheuqehandleClose1();
    } 
    else
    {
      
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
    }
   }
   
   async function ChequeClose()
   {
    if(ChqBankNameRef.current.length>0)
    {
    setChqBankName('');
    setChqAmount('');
    setChqNo('');
    setCheque('');

    }
    else
    {
    CheuqehandleClose1();
    }

   }




function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

async function BillCalc()
{

  PurDetTable=DtPurDetTableRef.current;

  var cnt1 = 0;
 
 



  var cnt1 = 0;
           try {
             cnt1 = PurDetTable.length;
           }
           catch (err) {
             cnt1 = 0;
           }
           let i=0;
           let PurWt=0;
           let PurAmount1=0;
           let PurTax=0;
           for (i = 0; i < cnt1; i++) {
             PurWt=val(PurWt)+val(PurDetTable[i].NetWt);
             PurAmount1=val(PurAmount1)+val(PurDetTable[i].PurAmount);
           }
           setPurchaseWt(PurWt.toFixed(2));
           setPurchaseAmount(PurAmount1.toFixed(2));


          //

          setBillAmount((val(PurchaseAmountRef.current)).toFixed(2));
          

          setNetAmount((val(BillAmountRef.current)-val(DiscountRef.current)+val(TaxAmountRef.current)).toFixed(0));


          setTotalPaid((val(CreditRef.current)+val(ChequeRef.current)+val(CashRef.current)).toFixed(2));

          setBalancePaid((val(NetAmountRef.current)-val(TotalPaidRef.current)).toFixed(2));

          if(BillAmountRef.current>0)
          setDisP((val(DiscountRef.current)/val(BillAmountRef.current)*100).toFixed(0));
          else
          setDisP(0);          
}


async function ControlSettings()
{

  document.getElementById("txtBillNo").disabled ='true';
  
  
  if((sessionStorage.getItem("PurchaseOnly_Action")=="Edit") || (sessionStorage.getItem("PurchaseOnly_Action")=="Delete"))
   {
  
    
    

   }

 



}

async function getxRefName()
{
  try
  {


    setxRefCustId(0);
    setxRefCustName('');

    
if(xRefMobileNoRef.current.length==10)
{
    
    let postData = {
      MobileNo :xRefMobileNoRef.current
  }

 
  const results = await apiService.postCall("purchaseonly/getcustname",postData);

 if (results != "-1") {


  if(results.data[0].length>0)
  {
  setxRefCustId(results.data[0][0].CustId);
  setxRefCustName(results.data[0][0].CustomerName);
}


}

} 
  }
  catch (error) {
    console.log(error);
  }
}


async function GetCustList(search)
{


  try
  {


    if(search.indexOf('{')==-1)
    {
    if(search.length<5)
    {
   setdtCust([]);
   setdtCust_Org([]);
   return;
    }
  }  
    
    let postData = {
      Search :search
  }

 

  const results = await apiService.postCall("purchaseonly/getcustlist",postData);

 if (results != "-1") {
   setdtCust(results.data[0]);
   setdtCust_Org(results.data[0]);

   CusthandleShow1();
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    setisNewBill(true);

  

    const results = await apiService.postCall("purchaseonly/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let PurDetail=results.data.PurDetail;
 

   if(PurDetail[0].length>0) 
   { 
    setDtPurDetTable(PurDetail[0]);
   
   }
   
 
  

 
  
   
   

 
   
      setBillNo(HeadData[0][0].BillNo);
      setBillDate(HeadData[0][0].BillDate);
      setEmpId1(HeadData[0][0].OprCode);
      setEmpName1(HeadData[0][0].OprName);
      setCustId(HeadData[0][0].CustId);
      setCustName(HeadData[0][0].CustomerName);
      setCustBillName(HeadData[0][0].PartyName);
      setMobile(HeadData[0][0].MobileNo);
      setAddress1(HeadData[0][0].Add1);
      setAddress2(HeadData[0][0].Add2);
      setAddress3(HeadData[0][0].Add3);
      setArea(HeadData[0][0].Area);
      setCity(HeadData[0][0].City);
      setPinCode(HeadData[0][0].Pincode);
      setPhoneNo(HeadData[0][0].PhoneNo);
      setEmailId(HeadData[0][0].Email);
      setAdharNo(HeadData[0][0].AdharNo);
      setPanNo(HeadData[0][0].PanNo);
      setPurchaseWt(HeadData[0][0].PurWt);
      setPurchaseAmount(HeadData[0][0].PurchaseAmount);
      setPurchaseTax(HeadData[0][0].PurTax);
      setBillAmount(HeadData[0][0].BillAmount);
      setDisP(HeadData[0][0].DiscountPer);
      setDiscount(HeadData[0][0].DiscountAmount);
      setCredit(HeadData[0][0].CreditAmount);
      setCash(HeadData[0][0].CashAmount);
      setCheque(HeadData[0][0].ChequeAmount);
      setNetAmount(HeadData[0][0].NetAmount);
      setTotalPaid(HeadData[0][0].AmountPaid);
      setBalancePaid(HeadData[0][0].BalancePaid);
      setChqBankName(HeadData[0][0].BankName);
      setChqNo(HeadData[0][0].ChequeNo);
      setChqDate(HeadData[0][0].ChequeDate);
      setChqAmount(HeadData[0][0].ChequeAmount);
      

   getLookup();



     
     

     
       
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function CustSave(){
	  try
		{
	
		
			
			if(xCustNameRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Customer Name",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }
	
      if(xMobileRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Mobile",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }

      
var Action="Add";
if(val(xCustIdRef.current)>0)
  Action="Edit";

		 
		let postData = {
			"Action" : Action,
			"EditId" : xCustId,
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"CustName": xCustNameRef.current,
      "MobileNo": xMobileRef.current,
      "Address1": xAddress1Ref.current,
			"Address2": xAddress2Ref.current,
      "Address3": xAddress3Ref.current,
      "Area": xAreaRef.current,
      "City": xCityRef.current,
      "PinCode": xPinCodeRef.current,
      "PhoneNo": xPhoneNoRef.current,
      "EmailId": xEmailIdRef.current,
      "AdharNo": xAdharNoRef.current,
      "PanNo": xPanNoRef.current,
      "RefCustId": xRefCustIdRef.current,
      "RefCustMobileNo": xRefMobileNoRef.current,
      "RefCustName":xRefCustNameRef.current,
      "RefRelation": RefxRelationRef.current,
    }

    

   const results = await apiService.postCall("purchaseonly/CustSave",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(Action=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);
      
     CustEntryhandleClose1();
    });
	
  }

  else if(Action=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);

      CustEntryhandleClose1();
    });
	
  }
	 
  else if(Action=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    CustEntryhandleClose1();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }
async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("PurchaseOnly_Action"),
			"EditId" : sessionStorage.getItem("PurchaseOnly_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "BillNo":BillNoRef.current,
      "BillDate":BillDateRef.current,
      "DtPurDetTable":DtPurDetTableRef.current,
      "EmpId1":EmpId1Ref.current,
      "EmpName1":EmpName1Ref.current,
      "CustId":CustIdRef.current,
      "CustName":CustNameRef.current,
      "CustBillName":CustBillNameRef.current,
      "CustRelation":"Own",
      "Mobile":MobileRef.current,
      "Address1":Address1Ref.current,
      "Address2":Address2Ref.current,
      "Address3":Address3Ref.current,
      "Area":AreaRef.current,
      "City":CityRef.current,
      "PinCode":PinCodeRef.current,
      "PhoneNo":PhoneNoRef.current,
      "EmailId":EmailIdRef.current,
      "AdharNo":AdharNoRef.current,
      "PanNo":PanNoRef.current,
      "PurchaseWt":PurchaseWtRef.current,
      "PurchaseAmount":PurchaseAmountRef.current,
      "PurchaseTax":PurchaseTaxRef.current,
      "BillAmount":BillAmountRef.current,
      "DisP":DisPRef.current,
      "Discount":DiscountRef.current,
      "Credit":CreditRef.current,
      "Cash":CashRef.current,
      "Cheque":ChequeRef.current,
      "NetAmount":NetAmountRef.current,
      "TotalPaid":TotalPaidRef.current,
      "BalancePaid":BalancePaidRef.current,
      "ChqBankName":ChqBankNameRef.current,
      "ChqNo":ChqNoRef.current,
      "ChqDate":ChqDateRef.current,
      "ChqAmount":ChqAmountRef.current
		}

    let ErrMsg="";

  

    if(val(postData.BalancePaid)!=0)
    {
      ErrMsg="Please Check Paid Amount";
    }


    if((postData.CustId==undefined)||(postData.CustId=='')||(postData.CustId=='0'))
    {
      ErrMsg="Please Enter Customer";
    }

    if((postData.EmpId1==undefined)||(postData.EmpId1=='')||(postData.EmpId1=='0'))
    {
      ErrMsg="Please Enter Employee Code";
    }

    
    if(postData.DtPurDetTable.length==0)
    {
      ErrMsg="Please Enter Purchase Details";
    }



    if(ErrMsg=="")
    {
    

   const results = await apiService.postCall("purchaseonly/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("PurchaseOnly_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("PurchaseOnly_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("PurchaseOnly_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }


function PurCalc()
{
let GrossWt=val(PurGrossWtRef.current);
let StoneWt=val(PurStoneWtRef.current);
let WasteP=val(PurWastePRef.current);
let Waste=0;
let NetWt=0;
let MC=val(PurMCRef.current);
let Rate=val(PurRateRef.current);
let StAmount=val(PurStoneAmtRef.current);
let Amount=0;




NetWt=val(val(GrossWt)-val(StoneWt)).toFixed(2);
Waste=val(val(NetWt)*val(WasteP)/100).toFixed(2);
NetWt=NetWt-Waste;

Amount=((val(NetWt)*val(Rate))+val(MC)+val(StAmount)).toFixed(2);

  
setPurAmount(Amount);
setPurNetWt(NetWt);
setPurWasteGrm(Waste);

}


 

  async function PurgridEdit (id) {

     

    PurDetTable=DtPurDetTable;

    var cnt = 0;
    try {
        cnt = PurDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }





    let i=0;

    for (i = 0; i < cnt; i++) {
        if (PurDetTable[i].ID == id) {

            setPurId(id);
            setPurBillNo(PurDetTable[i].BillNo);
            setPurBillDate(PurDetTable[i].BillDate);
            setPurMetal(PurDetTable[i].Metal);
            setPurPcs(PurDetTable[i].Pcs);
            setPurGrossWt(PurDetTable[i].GrossWt);
            setPurStoneWt(PurDetTable[i].StoneWt);
            setPurNetWt(PurDetTable[i].NetWt);
            setPurPurity(PurDetTable[i].Purity);
            setPurMC(PurDetTable[i].MC);
            setPurRate(PurDetTable[i].Rate);
            setPurStoneAmt(PurDetTable[i].StoneAmt);
            setPurWasteP(PurDetTable[i].WasteP);
            setPurWasteGrm(PurDetTable[i].WasteGrm);
            setPurAmount(PurDetTable[i].PurAmount);
            setPurCategory(PurDetTable[i].Category);
            setBillType(PurDetTable[i].BillType);
         
           
   
  await getPurCategory();
 
            break;

        }          
    }

    setDtPurDetTable(PurDetTable);
  
    PurchasehandleShow1();

}
  async function PurgridRemove (id) {


  
    PurDetTable=DtPurDetTable;
     
      var cnt = 0;
      try {
          cnt = PurDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((PurDetTable[i].ID == id))
          {
            PurDetTable.splice(i, 1);
              break;
          }
      }

      setDtPurDetTable(PurDetTable);
    
    setPurMetal('');
    
    await BillCalc();
    
    //Clear();

  }

  async function PurgridAdd () {


    let slno=PurIdRef.current;
    let BillNo=PurBillNoRef.current;
    let BillDate=PurBillDateRef.current;
    let Metal=PurMetalRef.current;
    let Category=(PurCategoryRef.current);
    let Pcs=val(PurPcsRef.current);
    let GrossWt=val(PurGrossWtRef.current);
    let StoneWt=val(PurStoneWtRef.current);
    let NetWt=val(PurNetWtRef.current);
    let WasteP=val(PurWastePRef.current);
    let WasteGrm=val(PurWasteGrmRef.current);
    let Wastage=val(PurWastageRef.current);
    let MC=val(PurMCRef.current);
    let Rate=val(PurRateRef.current);
    let StoneAmt=val(PurStoneAmtRef.current);
    let PurAmount=val(PurAmountRef.current);
    let Purity=val(PurPurityRef.current);
    let BillType=BillTypeRef.current;
    
  
  
    
  
  
  if ((Metal.length>0)&&(Category.length>0)&&(NetWt>0)&&(PurAmount>0)&&(Rate>0)&&(BillType.length>0))
  
  {
      PurDetTable=DtPurDetTable;
  
  
      var cnt = 0;
      try
      {
          cnt = PurDetTable.length;
         
      }
      catch(err)
      {
          cnt=0;
      }
  
  
  
      var found = false;
      var i=0;
  
      for (i = 0; i < cnt; i++) {
  
  
  
          if ((PurDetTable[i].ID == slno)) {
  
  
            PurDetTable[i].BillNo=BillNo;
            PurDetTable[i].BillDate=BillDate;
            PurDetTable[i].Metal=Metal;
            PurDetTable[i].Category=Category;
            PurDetTable[i].Pcs=Pcs;
            PurDetTable[i].GrossWt=GrossWt;
            PurDetTable[i].StoneWt=StoneWt;
            PurDetTable[i].Purity=Purity;
            PurDetTable[i].WasteP=WasteP;
            PurDetTable[i].WasteGrm=WasteGrm;
            PurDetTable[i].Wastage=WasteGrm;
            PurDetTable[i].NetWt=NetWt;
            PurDetTable[i].MC=MC;
            PurDetTable[i].Rate=Rate;
            PurDetTable[i].StoneAmt=StoneAmt;
            PurDetTable[i].PurAmount=PurAmount;
            PurDetTable[i].BillType=BillType;
          
            //det text box clear
  
            //PurchaseClear();
  
            PurchasehandleClose1();
  
            await BillCalc();



              found = true;
              break;
          }
          else {
  
  
          if ((PurDetTable[i].Metal == Metal) && (PurDetTable[i].Category == Category) && (PurDetTable[i].Pcs == Pcs) && (parseFloat(PurDetTable[i].NetWt).toFixed(2) == parseFloat(NetWt).toFixed(2))) {
                  swal({
          title: "",
          text: "Already Found",
          icon: "info",
          button: "Ok"
  
          });
  
                  found = true;
                  break;
  
              }
          }
      }
  
  
      if (found == false) {
  
          var row = {
              "ID": parseInt(cnt) + 1
              , "BillNo":BillNo
              , "BillDate":BillDate
              , "Metal":Metal
              , "Category":Category
              , "Pcs":Pcs
              , "GrossWt":GrossWt
              , "StoneWt":StoneWt
              , "Purity":Purity
              , "WasteP":WasteP
              , "WasteGrm":WasteGrm
              , "Wastage":WasteGrm
              , "NetWt":NetWt
              , "Rate":Rate
              , "MC":MC
              , "StoneAmt":StoneAmt
              , "PurAmount":PurAmount
              , "BillType":BillType

          };
  
              PurDetTable[cnt] = row;
  
           //PurchaseClear();
           PurchasehandleClose1();
  
           await BillCalc();


           //Calc();
  
             
  
      }
    
    await setDtPurDetTable(PurDetTable);
  
  
  
  
  
    //alert(JSON.stringify(DtDetTable));
  
   PurCalc();
  
  
  }
  else
  {
  
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
  
  
  //alert("Fill All Data");
  }
  
  }
  


async function getPurCategory()
{
  try {

  let postData = {
    "PurMetal" : PurMetalRef.current
   };
   

  const results = await apiService.postCall("purchaseonly/getpurcategory",postData);

  if (results != "-1") {
    setdtCategory(results.data[0]);
   }
} catch (error) {
     console.log(error);
   }
}



  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0
    };
		
    const results = await apiService.postCall("purchaseonly/Lookup",postData);

	 if (results != "-1") {

    setdtEmp(results.data[0][0]);
    setdtChqBank(results.data[1][0]);
    setdtMetal(results.data[2][0]);
    setdtCategory(results.data[3][0]);
    setdtBillType(results.data[4][0]);
   
    
    let Relation=[
      {"Relation":"Own"},
      {"Relation":"Father"},
      {"Relation":"Mother"},
      {"Relation":"Son"},
      {"Relation":"Daughter"},
      {"Relation":"Husband"},
      {"Relation":"Wife"},
      {"Relation":"Brother"},
      {"Relation":"Sister"},
      {"Relation":"Grandfather"},
      {"Relation":"Grandmother"},
      {"Relation":"Grandson"},
      {"Relation":"Granddaughter"},
      {"Relation":"Uncle"},
      {"Relation":"Aunt"},
      {"Relation":"Son-in-law"},
      {"Relation":"Daughter-in-law"},
      {"Relation":"Cousins"},
      {"Relation":"Friend"},
      {"Relation":"Others"}
   
    ]

  
    setdtCustRelation(Relation);




      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/sales/purchaseonly/list');
  };


  
  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

         
                <div className='row'>
                  <div className='col-lg-8'>
                       
                        <div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Purchase Bill No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={BillNo}  />
                          </div>
                         
                          <div className='col-md-4'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" value={BillDate} onChange={(e)=>setBillDate(e.target.value)} />
                          </div>
						  
                         
                          

</div>
</div>


                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>

                       
   
  
     

     
      
    <div className="table-responsive mt-4" >
			 
   
       	   
       <Table striped id="basic-table"  className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
             <th>Metal</th>
             <th>Gategory</th>
             <th>Pcs</th>
             <th>Gross Wt</th>
             <th>Waste</th>  
             <th>Stone Wt</th>
             <th>Net Wt</th>  
             <th>Rate</th>  
             <th>Amount</th>  
             
   <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtPurDetTable.map((item) => (
           <tr>
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>PurgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>  

             <td>{item.Metal}</td>
             <td>{item.Category}</td>
             <td>{item.Pcs}</td>
             <td>{item.GrossWt}</td>                 
             <td>{item.WasteGrm}</td>
             <td>{item.StoneWt}</td>
             <td>{item.NetWt}</td>
             <td>{item.Rate}</td>  
             <td>{item.PurAmount}</td>  
            
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>PurgridRemove(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
             )
             )
              }     
         </tbody>
       </Table>
<div className="EntryPan" >
<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Delete" to="#" onClick={PurchasehandleShow1}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>



</div>


    


     </div>
     
     
   
      <div className='row'>

      <div className='col-lg-8'>
      <Form className='form-horizontal'>
      <div className='row'>
       <div className='col-md-4'>
      <Form.Label><span className='spanLink' onClick={CustOpen}>Mobile No</span></Form.Label>
      <Form.Control type="text" Readonly="Readonly" value={Mobile} placeholder="" className='txtReadOnly'  />
    </div>
    <div className='col-md-8'>
      <Form.Label>Customer Name</Form.Label>
      <Form.Control type="text" Readonly="Readonly"  placeholder=""  value={CustName}  className='txtReadOnly' />
      <Form.Control type="hidden" Readonly="Readonly" value={CustId}  placeholder=""   />
    </div>
    </div>
</Form>

</div>

<div className='col-lg-4'>
  </div>
<div className='col-lg-12' hidden={ShowCustBillDetail} id="divBillingName">
<div className='row'>
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Billing Name</Form.Label>
      <Form.Control type="text" value={CustBillName} onChange={(e)=>setCustBillName(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Address</Form.Label>
      <Form.Control type="text" value={Address1} onChange={(e)=>setAddress1(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address2} onChange={(e)=>setAddress2(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address3} onChange={(e)=>setAddress3(e.target.value)} placeholder=""   />
    </div>
</div>
  
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Area</Form.Label>
      <Form.Control type="text" value={Area} onChange={(e)=>setArea(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>City</Form.Label>
      <Form.Control type="text" value={City} onChange={(e)=>setCity(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Pincode</Form.Label>
      <Form.Control type="text" value={PinCode} onChange={(e)=>setPinCode(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Email Id</Form.Label>
      <Form.Control type="text" value={EmailId} onChange={(e)=>setEmailId(e.target.value)} placeholder=""   />
    </div>
</div>



<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Adhar No</Form.Label>
      <Form.Control type="text" value={AdharNo} onChange={(e)=>setAdharNo(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Pan No</Form.Label>
      <Form.Control type="text" value={PanNo} onChange={(e)=>setPanNo(e.target.value)} placeholder=""   />
    </div>
    
   
</div>


</div>
</div>



        <div className='col-lg-2'>

        <div className='col-md-12'>
      <Form.Label>Purchase Wt</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={PurchaseWt} placeholder="" className='txtReadOnly'   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Purchase Amount</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={PurchaseAmount}   placeholder="" className='txtReadOnly'   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Tax</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={PurchaseTax}  placeholder="" className='txtReadOnly'   />
    </div>

        </div>


        <div className='col-lg-2'>

<div className='col-md-12'>
  <Form.Label>Bill Amount</Form.Label>
  <Form.Control type="number" Readonly="Readonly"  value={BillAmount} placeholder=""  className='txtReadOnly'  />
</div>

<div className='col-md-12'>
  <Form className='form-horizontal'>
  <Form.Label>Discount</Form.Label>
  <div className='row'>
    <div className='col-md-5'> <Form.Control type="number" value={DisP} onKeyUp={BillCalc}  onChange={(e)=>setDisP(e.target.value)} className="txtReadOnly" Readonly="Readonly"  placeholder=""   />
 </div>
 <div className ='col-md-7'> <Form.Control className='col-md-10' type="number" onKeyUp={BillCalc}  value={Discount} onChange={(e)=>setDiscount(e.target.value)}  placeholder=""   />
 </div>
</div>
</Form>
</div>




<div className='col-md-12'>
  <Form.Label>Credit</Form.Label>
  <Form.Control type="number" value={Credit} onKeyUp={BillCalc} onChange={(e)=>setCredit(e.target.value)}  placeholder=""   />
</div>



    </div>
    <div className='col-lg-2'>

      


<div className='col-md-12'>
  <Form.Label><span className='spanLink' onClick={ChequeOpen}>Cheque</span></Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={Cheque} onChange={(e)=>setCheque(e.target.value)}  placeholder=""  className='txtReadOnly'  />
</div>

<div className='col-md-12'>
  <Form.Label>Cash</Form.Label>
  <Form.Control type="number" value={Cash} onKeyUp={BillCalc} onChange={(e)=>setCash(e.target.value)} placeholder=""   />
</div>

<div className='col-md-12'>
  <Form.Label>Total Paid</Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={TotalPaid} onChange={(e)=>setTotalPaid(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>


      </div>

    
     
      
      <div className='col-lg-2'>

      




   


<div className='col-md-12'>
  <Form.Label>Net Amount</Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={NetAmount} onChange={(e)=>setNetAmount(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>


<div className='col-md-12'>
  <Form.Label>Balance</Form.Label>
  <Form.Control type="number" Readonly="Readonly" value={BalancePaid} onChange={(e)=>setBalancePaid(e.target.value)}  placeholder="" className='txtReadOnly'   />
</div>

</div>
  
     </div>

    
      <div className='row'>

      <div className='col-lg-2'>
      <div className='col-md-12'>
  <Form.Label>Emp Id</Form.Label>
  <Form.Control type="text" value={EmpId1} onChange=
                            {
                              (e) => {
                            setEmpId1(e.target.value);
                            getEmpName(1);
                              }
                              } placeholder=""   />
</div>



</div>

<div className='col-lg-4'>
      <div className='col-md-12'>
  <Form.Label>Emp Name</Form.Label>
  <Form.Control type="text"  placeholder="" value={EmpName1}  className="txtReadOnly" Readonly="ReadOnly"  />
</div>



</div>
        </div>
    

                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
             	
          
          
				
                <Modal show={Purchaseshow1}  className=".modal-xl " id="EntryModal2"  >
                  <Modal.Header>
                    <Modal.Title>Purchase Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-2' hidden="true">
                              <Form.Label><span className='spanLink'>Bill No</span></Form.Label>
                              <Form.Control type="text" id="txtPurBillNo" Readonly="Readonly" className='txtReadOnly' value={PurBillNo} onChange={(e)=>setPurBillNo(e.target.value)}  placeholder="" />
                        
                            </div>
                    
                            <div className='col-md-2' hidden="true">
                            <Form.Label>Bill Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtPurBillDate" placeholder="" value={PurBillDate} onChange={(e)=>setPurBillDate(e.target.value)} />
                          </div>

                            <div className='col-md-3'>
                              <Form.Label>Metal</Form.Label>
                            <Select className="form-select-search" id="txtStProductName" 
                             options={dtMetal}
                             value={dtMetal.filter(function(option) {
                              return option.value === PurMetal;
                            })}
                            onChange=
                            {
                              (e) => {
                            setPurMetal(e.value);
                            getPurCategory();
                              }
                              }
                             disabled={false}>
              				       </Select>     
                            </div>
                            <div className='col-md-3'>
                              <Form.Label>Category</Form.Label>
                          <Select className="form-select-search" id="txtStProductName" 
                             options={dtCategory}
                             value={dtCategory.filter(function(option) {
                              return option.value === PurCategory;
                            })}
                            onChange=
                            {
                              (e) => {
                            setPurCategory(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>  
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Purchase Type</Form.Label>
                            <Select className="form-select-search" id="txtBillType1" 
                             options={dtBillType}
                             value={dtBillType.filter(function(option) {
                              return option.value === BillType; 
                            })}
                            onChange=
                            {
                              (e) => {
                            setBillType(e.value);
                           
                              }
                              }
                             disabled={false}>
              				       </Select>     
                            </div>
                
                
                        
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="number" id="txtPcs" value={PurPcs}
                            onChange=
                            {
                              (e) => {
                            setPurPcs(e.target.value);
                            PurCalc();
                              }
                              }
                              placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="number" id="txtGrossWt" value={PurGrossWt}
                             onChange=
                            {
                              (e) => {
                            setPurGrossWt(e.target.value);
                            PurCalc();
                              }
                              }  placeholder=""  />
                            </div>
                            
                           

                            <div className='col-md-2'>
                              <Form.Label>Stone Wt</Form.Label>
                            <Form.Control type="number" id="txtPurStoneWt" value={PurStoneWt} 
                             onChange=
                            {
                              (e) => {
                            setPurStoneWt(e.target.value);
                            PurCalc();
                              }
                              }placeholder="" />
                            </div>

                            
                           
                           
                            <div className='col-md-2'>
                              <Form.Label>Purity</Form.Label>
                            <Form.Control type="number" id="txtPurPurity" value={PurPurity} 
                             onChange=
                            {
                              (e) => {
                            setPurPurity(e.target.value);
                            PurCalc();
                              }
                              } placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste %</Form.Label>
                            <Form.Control type="number" id="txtPurWasteP" value={PurWasteP} 
                             onChange=
                            {
                              (e) => {
                            setPurWasteP(e.target.value);
                            PurCalc();
                              }
                              } placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste Grm</Form.Label>
                            <Form.Control type="number"  className='txtReadOnly' Readonly="Readonly" id="txtPurWasteGrm" value={PurWasteGrm}  onChange=
                            {
                              (e) => {
                            setPurWasteGrm(e.target.value);
                              }
                              }  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="number" id="txtPurNetWt"  className='txtReadOnly' Readonly="Readonly" value={PurNetWt}  onChange=
                            {
                              (e) => {
                            setPurNetWt(e.target.value);
                              }
                              } placeholder=""   />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="number" id="txtPurRate" value={PurRate}  onChange=
                            {
                              (e) => {
                            setPurRate(e.target.value);
                            PurCalc();
                              }
                              }  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Stone Amount</Form.Label>
                            <Form.Control type="number" id="txtPurStAmt" value={PurStoneAmt}  onChange=
                            {
                              (e) => {
                            setPurStoneAmt(e.target.value);
                            PurCalc();
                              }
                              }  placeholder="" />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="number" id="txtPurAmt" value={PurAmount}  onChange=
                            {
                              (e) => {
                            setPurAmount(e.target.value);
                            
                              }
                              }  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                           
                            
                          


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={PurgridAdd}>OK</Button>
					<Button type="button" className="detbutton" variant="btn btn-primary" onClick={PurchaseClear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				  

                <Modal show={Chequeshow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>Cheque/DD Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                        <div className='col-md-12'>
                              <Form.Label>Bank Name</Form.Label>
                              <Select className="form-select-search" 
                             options={dtChqBank}
                             value={dtChqBank.filter(function(option) {
                              return option.value === ChqBankName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setChqBankName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                     
                            </div>

                        <div className='col-md-12'>
                              <Form.Label>Cheque/DD No</Form.Label>
                              <Form.Control type="text"   value={ChqNo} onChange=
                            {
                              (e) => {
                            setChqNo(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date"  value={ChqDate} onChange=
                            {
                              (e) => {
                            setChqDate(e.target.value);
                              }
                              } placeholder=""  />
                          </div>

                            <div className='col-md-12'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number" value={ChqAmount} onChange=
                            {
                              (e) => {
                            setChqAmount(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                                 


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeOK}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
            

                <Modal show={Custshow1} className=" .modal-xl" onHide={CusthandleClose1} id="EntryModal1" >
                  <Modal.Header closeButton>
                    <Modal.Title>Customer Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-12" >

                    <div className="table-responsive mt-4" id="EntryModalCust" >
			 
       <div className="row">
                    <div className='col-md-11'>
                              <Form.Control type="text"  value={CustSearchTxt}     onChange=
                            {
                              (e) => {
                            setCustSearchTxt(e.target.value);
                            GetCustList(e.target.value);
                              }
                              }  placeholder="Search (Minimum 5 Letters)" />
</div>
<div className='col-md-1'>
                <Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick= {
                              (e) => {
                            setxMobile(CustSearchTxtRef.current);
                            setxCustId(0);
                            setxCustName('');
                            setxAddress1('');
                            setxAddress2('');
                            setxAddress3('');
                            setxCity('');
                            setxPinCode('');
                            setxArea('');
                            setxPhoneNo('');
                            setxEmailId('');

                            CustEntryhandleShow1();
                              }
                              } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>

                      </div>
                      </div>
                      
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Select</th>   
           <th>Customer Name</th>
             <th>Mobile No</th>
             <th>Area</th>
             <th>City</th>   
             <th>Edit</th>
         
           </tr>
         </thead>
         <tbody>
         {dtCust.map((item) => (
           <tr >
             
             <td>

                                  

    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustSelect(item.CustId)} >
                   <span className="btn-inner">

                   <svg class="icon-32" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
              <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                
              </svg>  

                     
                   </span>
                 </Link>
   </td>
             <td>{item.CustomerName}</td>
             <td>{item.Mobile}</td>
             <td>{item.Area}</td>
             <td>{item.City}</td>
             
           

             <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustEdit(item.CustId)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             

           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>

     </div>


				
                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>



                <Modal show={CustEntryshow1}  className=".modal-xl" id="EntryModal3" >
                  <Modal.Header >
                    <Modal.Title>Customer Detail</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                       <div className='col-md-4'>

                        <div className='col-md-12'>
                              <Form.Label>Customer Name</Form.Label>
                              <Form.Control type="text"   value={xCustName} onChange=
                            {
                              (e) => {
                            setxCustName(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                              <Form.Label>Mobile No</Form.Label>
                              <Form.Control type="text"  value={xMobile} onChange=
                            {
                              (e) => {
                            setxMobile(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              <div className='col-md-12'>
                              <Form.Label>Address</Form.Label>
                              <Form.Control type="text"  value={xAddress1} onChange=
                            {
                              (e) => {
                            setxAddress1(e.target.value);
                              }}   placeholder="" />
                              </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                         <Form.Control type="text"  value={xAddress2} onChange=
                            {
                              (e) => {
                            setxAddress2(e.target.value);
                              }}   placeholder="" />
                                         </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                               <Form.Control type="text"  value={xAddress3} onChange=
                            {
                              (e) => {
                            setxAddress3(e.target.value);
                              }}   placeholder="" />

                            </div>
                            
                            </div>

                            <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Area</Form.Label>
                              <Form.Control type="text"  value={xArea} onChange=
                            {
                              (e) => {
                            setxArea(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>City</Form.Label>
                              <Form.Control type="text"  value={xCity} onChange=
                            {
                              (e) => {
                            setxCity(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pincode</Form.Label>
                              <Form.Control type="text"  value={xPinCode} onChange=
                            {
                              (e) => {
                            setxPinCode(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Phone</Form.Label>
                              <Form.Control type="text"  value={xPhoneNo} onChange=
                            {
                              (e) => {
                            setxPhoneNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Email Id</Form.Label>
                              <Form.Control type="text"  value={xEmailId} onChange=
                            {
                              (e) => {
                            setxEmailId(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              </div>


                              <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Adhar No</Form.Label>
                              <Form.Control type="text"  value={xAdharNo} onChange=
                            {
                              (e) => {
                            setxAdharNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pan No</Form.Label>
                              <Form.Control type="text"  value={xPanNo} onChange=
                            {
                              (e) => {
                            setxPanNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Mobile No</Form.Label>
                              <Form.Control type="text"  value={xRefMobileNo} onChange=
                            {
                              (e) => {
                            setxRefMobileNo(e.target.value);
                            getxRefName();
                           
                              }} placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Name</Form.Label>
                              <Form.Control type="text"  value={xRefCustName} Readonly="readonly" className="txtReadOnly" onChange=
                            {
                              (e) => {
                            setxRefCustName(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Relation</Form.Label>
                              <select className="form-select"  value={xRefRelation}
                              onChange=
                              {
                                (e) => {
                              setxRefRelation(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtCustRelation.map(
                              (item)=>(
                              <option value={item.Relation}>{item.Relation}</option>
                              )
                              )
                              }
                             </select>

</div>

                              </div>
</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustSave}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustEntryClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
                
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
